<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <form class="ui form" [formGroup]="headerForm">
      <div
        class="field"
        [ngClass]="displayFieldCss('headerKey')"
        appMargin
        marginB="15px"
      >
        <label class="required">Header</label>
        <input type="text" formControlName="headerKey" />

        <app-field-error-display
          [displayError]="isFieldValid('headerKey')"
          errorMsg="Please provide detail"
        >
        </app-field-error-display>
      </div>
      <div
        class="field"
        [ngClass]="displayFieldCss('headerValue')"
        appMargin
        marginB="15px"
      >
        <label class="required"
          >Value
          <small style="font-size: 12px">
            ( Multiple values can be added as comma seperated string)</small
          ></label
        >
        <input type="text" formControlName="headerValue" />

        <app-field-error-display
          [displayError]="isFieldValid('headerValue')"
          errorMsg="Please provide a valid Value"
        >
        </app-field-error-display>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: transparent; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    (click)="extraData.isAdd ? add() : update()"
    [disabled]="pending || !headerForm.valid"
    class="ui primary button"
  >
    Save
  </button>
</div>
